import AsyncStatus from 'mini-people-common/lib/schema/AsyncStatus';
import React, { useContext, useMemo } from 'react';
import { LPC_STRINGS_MODULE_NAME, SAMPLE_LPC_STRING_KEY } from '../utils/constants';
import { MountPropsContextValue, MountPropsProviderProps } from './MountPropsProvider.types';
import { useMiniStrings } from 'mini-hooks/lib/useMiniStrings';

const MountPropsContext = React.createContext<MountPropsContextValue | undefined>(undefined);

/**
 * Context provider to pass the MountProps coming from the people card host app to the card subtree
 * @param props
 */
export const MountPropsProvider: React.FC<MountPropsProviderProps> = props => {
    // Checking if the strings module is loaded and setting the status in the context
    const areStringsLoaded = useMiniStrings(LPC_STRINGS_MODULE_NAME, SAMPLE_LPC_STRING_KEY);
    const assetsAsyncStatus = areStringsLoaded ? AsyncStatus.Loaded : AsyncStatus.Loading;

    const value = useMemo<MountPropsContextValue>(
        () => ({ ...props.mountProps, assetsAsyncStatus }),
        [areStringsLoaded]
    );

    return <MountPropsContext.Provider value={value}>{props.children}</MountPropsContext.Provider>;
};

// Selector function to get the MountProps from the context
export const useMountProps = (): MountPropsContextValue => useContext(MountPropsContext);
